import { DateTimePickerProps } from 'react-datetime-picker'
import dayjs from 'dayjs'
import React from 'react'
import { Icon } from '@musinsa/mwms-ds'

export const DATE_PICKER_CN = 'mwms-datetime__picker'
export const DATE_PICKER_CAL_CN = 'mwms-datetime__calendar'
export const DATE_PICKER_TILE_CN = 'mwms-datetime__tile'

export const DATE_PICKER_SIZE_MD_CN = 'datetime__picker--md'
export const DATE_PICKER_SIZE_LG_CN = 'datetime__picker--lg'
export const DATE_PICKER_SELECT_STYLE_CN = 'datetime__picker--select'
export const DATE_PICKER_CAL_FIXED_CN = 'mwms-datetime__calendar--fixed'
export const DATE_PICKER_CAL_V2_ERROR_CN = 'mwms-datetime__calendar--error'

export const DATE_PICKER_V2_CN = 'mwms-datetime__picker-v2'
export const DATE_PICKER_CAL_V2_CN = 'mwms-datetime__calendar-v2'

class DatePickerUtils {
  static getValidDate = (val: string | Date | null | undefined) => {
    return val && dayjs(val).isValid() ? dayjs(val).toDate() : null
  }

  static getDatePickerDefaultOpts = (
    opts: { showTimeSelect?: boolean; showAmPm?: boolean; fixedCalendar?: boolean } = {},
  ): DateTimePickerProps => ({
    disableClock: !opts.showTimeSelect,
    locale: 'ko',
    calendarType: 'gregory',
    format: opts.showTimeSelect ? (opts.showAmPm ? 'y.MM.dd HH:mm:ss a' : 'y.MM.dd HH:mm:ss') : 'y-MM-dd',
    formatDay: (locale: string | undefined, date: Date) => date.getDate().toString(),
    formatMonthYear: (locale: string | undefined, date: Date) => dayjs(date).format('YYYY.MM'),
    calendarIcon: <Icon name="calendar" size={16} color="gray500" style={{ paddingLeft: '4px' }} />,
    prevLabel: <Icon name="arrow-left-filled" size={24} color="gray500" />,
    nextLabel: <Icon name="arrow-right-filled" size={24} color="gray500" />,
    clearIcon: null,
    prev2Label: null,
    next2Label: null,
    yearPlaceholder: 'YYYY',
    monthPlaceholder: 'MM',
    dayPlaceholder: 'DD',
    hourPlaceholder: 'HH',
    minutePlaceholder: 'mm',
    secondPlaceholder: 'ss',
    portalContainer: opts.fixedCalendar ? document.getElementById('root') : null,
    maxDate: new Date('9999-01-01'),
  })

  static onForceToClose = (type: 'range' | 'simple', calCn: string) => {
    const calWrapCn = `${type === 'range' ? 'react-datetimerange-picker' : 'react-datetime-picker'}__calendar`
    const calWrapCn_open = `${calWrapCn}--open`
    const calWrapCn_close = `${calWrapCn}--closed`

    const $cal = document.getElementsByClassName(calCn)?.[0] as HTMLElement
    if (!$cal) return

    // [캘린더 Toggle]
    if ($cal.classList.contains(calWrapCn_open)) {
      $cal.classList.remove(calWrapCn_open)
      $cal.classList.add(calWrapCn_close)

      $cal.blur()
    }
  }

  // [캘린더 Toggle] 스크롤로 강제로 캘린더 닫은 경우, 캘린더가 안열리는 이슈가 있어서 강제 오픈 처리
  static onForceToOpen = (type: 'range' | 'simple', calCn: string, cb?: Function) => {
    const calWrapCn = `${type === 'range' ? 'react-datetimerange-picker' : 'react-datetime-picker'}__calendar`
    const calWrapCn_open = `${calWrapCn}--open`
    const calWrapCn_close = `${calWrapCn}--closed`

    const $cal = document.getElementsByClassName(calCn)?.[0]
    if (!$cal) return

    // [캘린더 Toggle]
    if ($cal.classList.contains(calWrapCn_close)) {
      $cal.classList.remove(calWrapCn_close)
      $cal.classList.add(calWrapCn_open)
    }

    if (cb) cb()
  }

  static onSelectAllOnDateInput = () => {
    const $active = document.activeElement as HTMLInputElement
    if (!$active || $active.tagName !== 'INPUT') return

    setTimeout(() => $active.select(), 0)
  }

  static onFixPositionOfCal = ({
    id,
    size,
    calCn,
    placement = 'bottom',
  }: {
    id: string
    size?: 'sm' | 'md' | 'lg'
    calCn: string
    placement?: 'top' | 'bottom'
  }) => {
    setTimeout(() => {
      const $wrap = document.getElementById(id)
      if (!$wrap) return

      const $cal = document.getElementsByClassName(calCn)?.[0] as HTMLElement
      if (!$cal) return

      // [캘린더 Toggle]
      const rect = $wrap.getBoundingClientRect()
      const inputHeight = size === 'md' ? 28 : 24

      if (placement === 'top') {
        $cal.style.top = rect.top + document.body.getBoundingClientRect().top - $cal.offsetHeight + 'px'
      }

      if (placement === 'bottom') {
        $cal.style.top = rect.top + document.body.getBoundingClientRect().top + inputHeight + 'px'
      }

      $cal.style.left = rect.left + document.body.getBoundingClientRect().left + 'px'
    }, 0)
  }
}

export default DatePickerUtils
